module.exports = __webpack_public_path__ + "static/media/00376-ACTUALIZACION TARIFAS REGISTRALES 2024.f1124f1d.pdf";